// Packages
import { Component } from "react";
import { FormGroup } from "reactstrap";
import { Link, withRouter } from "react-router-dom";
import moment from "moment";
import Multiselect from "multiselect-react-dropdown";

// Views
import SchoolAdminDashboard from "./schoolAdminDashboard";
import ElevationScroll from "./ElevationScroll";

// Styles
import "../schoolAdminPortal/schoolAdmin.css";

// Assets
import backarrow from "../../assets/images/back-arrow.png";

// Material Ui
import Toolbar from "@material-ui/core/Toolbar";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import PhotoSizeSelectActualOutlinedIcon from "@material-ui/icons/PhotoSizeSelectActualOutlined";
import Avatar from "@material-ui/core/Avatar";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import successimg from "../../assets/images/successimg.png";
import DialogContent from "@material-ui/core/DialogContent";
import close from "../../assets/images/crosstick.png";
import { FaTimes } from "react-icons/fa";

import { getFromLocalStorage } from "../../utils/webStorage";
import { CircularProgress } from "@material-ui/core";

// All Urls

// Services
import userService from "../../services/user.service";

class EditTeams extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {},
      errors: {},
      coachesData: [],
      atheleteData: [],
      selectedValueCoaches: [],
      selectedValueAthelete: [],
      athletes: [],
      coaches: [],
      allSportsList: [],
      stateList: [],
      selectedCOuntry: "",
      countryId: null,
      jersey: "",

      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      graduation: "",
      state: "",
      schoolName: "",
      schoolType: "",
      sport: "",
      status: "",
      position: "",
      anyMessage: "",
      fileAddress: null,
      uploadId: null,
      imagePreviewUrl: "",
      schoolId: null,
      createdAt: null,
      teamId: null,
      submitting: false,
      disabled: false,
    };

    this.registerSchoolAdmin = this.registerSchoolAdmin.bind(this);
    this.changeHandlerForLogo = this.changeHandlerForLogo.bind(this);
    this.handleSubmissionForLogo = this.handleSubmissionForLogo.bind(this);
  }

  changeHandlerForLogo = (event) => {
    this.selectedFile = event.target.files[0];
    let reader = new FileReader();
    let file = event.target.files[0];

    reader.onloadend = () => {
      this.setState({
        file: file,
        imagePreviewUrl: reader.result,
        imageUploadText: "Change profile photo",
        isRemovedPhoto: true,
      });
    };
    reader.readAsDataURL(file);
    this.handleSubmissionForLogo();
  };

  handleSubmissionForLogo = () => {
    this.setState({
      submitting: true,
    });
    const data = new FormData();
    data.append("file", this.selectedFile);
    userService
      .postLogoForAll(data)

      .then((res) => {
        this.fileAddress = res.data.data[0].filePath;
        this.fileId = res.data.data[0].id;
        this.uploadId = res.data.data[0].id;
        this.setState({
          submitting: false,
        });
      });
  };

  getAllCoachesData(schoolId) {
    this.setState({
      submitting: false,
    });
    userService
      .getAllCoachesDropdown(schoolId)
      .then((response) => {
        var coachesDataTest = response.data.data;
        this.setState({ coachesDataTest });
        if (coachesDataTest != null) {
          var coachesData = [];
          for (let i = 0; i < coachesDataTest.length; i++) {
            var obj = {};
            obj["name"] = coachesDataTest[i].fullName;
            obj["id"] = coachesDataTest[i].id;
            coachesData.push(obj);
          }
          this.setState({ coachesData });
        }
        this.setState({
          submitting: false,
        });
      })
      .catch((error) => {
        this.setState({
          submitting: false,
        });
        console.error("There was an error!", error);
      });
  }

  getAllAtheleteData(schoolId) {
    this.setState({
      submitting: true,
    });
    userService
      .getAllAtheleteDropdown(schoolId)
      .then((response) => {
        var atheleteDataTest = response.data.data;
        this.setState({ atheleteDataTest });
        if (atheleteDataTest != null) {
          var atheleteData = [];
          for (let i = 0; i < atheleteDataTest.length; i++) {
            var obj = {};
            obj["name"] = atheleteDataTest[i].fullName;
            obj["id"] = atheleteDataTest[i].id;
            atheleteData.push(obj);
          }
          this.setState({ atheleteData });
        }
        this.setState({
          submitting: false,
        });
      })
      .catch((error) => {
        this.setState({
          submitting: false,
        });
        console.error("There was an error!", error);
      });
  }

  //pop up
  openDialog() {
    this.setState({ open: !this.state.open });
  }
  closeDialog() {
    this.setState({ open: !this.state.open });
  }

  openDialogSuccess() {
    this.setState({ openSuccess: !this.state.openSuccess });
  }
  closeDialogSuccess() {
    this.setState({ openSuccess: !this.state.openSuccess });
  }

  //end
  componentDidMount() {
    this.setState({
      submitting: true,
    });
    const team = document.getElementById("Team");
    if (team) {
      team.classList.add("btnActive");
    }
    const {
      match: { params },
    } = this.props;
    this.id = params.teamId;
    var schoolId = getFromLocalStorage("schoolId");
    this.setState({ schoolId });
    this.getTeamsByIdNxt();
    this.getAllCoachesData(schoolId);
    this.getAllAtheleteData(schoolId);
    this.setState({
      submitting: false,
    });
  }

  getTeamsByIdNxt = () => {
    this.setState({
      submitting: true,
    });
    userService
      .getTeamsDetails(this.id)
      .then((response) => {
        const {
          id,
          createdAt,
          teamName,
          teamId,
          uploadedLogo,
          athletes,
          coach,
          teamCoaches,
          teamAthelets,
        } = response.data.data;
        this.setState({
          createdAt,
          teamName,
          teamId,
        });
        this.setState({ teamId: id });
        if (uploadedLogo != null) {
          this.setState({ imagePreviewUrl: uploadedLogo.filePath });
          this.uploadId = uploadedLogo.id;
        }

        if (athletes != null) {
          const _athletes = [];
          for (let i = 0; i < athletes.length; i++) {
            _athletes.push(athletes[i].id);
          }
          this.setState({ athletes: _athletes });
          // this.uploadId = uploadedLogo.id;
        }

        if (coach != null) {
          const coaches = [];
          for (let i = 0; i < coach.length; i++) {
            coaches.push(coach[i].id);
          }
          this.setState({ coaches });
          // this.uploadId = uploadedLogo.id;
        }

        if (teamCoaches != null) {
          var selectedValueCoaches = [];
          for (let i = 0; i < teamCoaches.length; i++) {
            selectedValueCoaches.push(teamCoaches[i]);
          }
          this.setState({ selectedValueCoaches });
        }
        if (teamAthelets != null) {
          var selectedValueAthelete = [];
          for (let j = 0; j < teamAthelets.length; j++) {
            selectedValueAthelete.push(teamAthelets[j]);
          }
          this.setState({ selectedValueAthelete });
        }
        this.setState({
          submitting: false,
        });
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  onSelect = (selectedList, selectedItem) => {
    var coaches = [];
    for (let i = 0; i < selectedList.length; i++) {
      coaches.push(selectedList[i].id);
      this.setState({ coaches });
    }
  };
  onRemove = (selectedList, removedItem) => {
    var coaches = [];
    for (let i = 0; i < selectedList.length; i++) {
      coaches.push(selectedList[i].id);
      this.setState({ coaches });
    }
  };
  onSelectAthelete = (selectedList, selectedItem) => {
    var athletes = [];
    for (let i = 0; i < selectedList.length; i++) {
      athletes.push(selectedList[i].id);
      this.setState({ athletes });
    }
  };
  onRemoveAthelete = (selectedList, removedItem) => {
    var athletes = [];
    for (let i = 0; i < selectedList.length; i++) {
      athletes.push(selectedList[i].id);
      this.setState({ athletes });
    }
  };

  validateForm() {
    let errors = {};
    let formIsValid = true;

    if (!this.state.teamName) {
      formIsValid = false;
      errors["teamName"] = "*Please enter Team name.";
    }

    this.setState({
      errors: errors,
    });
    return formIsValid;
  }

  registerSchoolAdmin(e) {
    this.setState({
      submitting: true,
      disabled: true,
    });
    e.preventDefault();
    const { teamName, athletes, coaches, schoolId, teamId } = this.state;
    const { history } = this.props;
    userService
      .editTeamsDetails(
        athletes,
        coaches,
        schoolId,
        teamName,
        teamId,
        this.uploadId
      )
      .then((response) => {
        this.setState({
          disabled: false,
        });
        if (response.status === 200) {
          this.openDialogSuccess();
        } else {
          alert("Something went wrong");
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
        this.setState({
          disabled: false,
        });
      });
    this.setState({
      submitting: false,
      disabled: true,
    });
  }
  render(props) {
    const { imageUploadText, submitting, disabled } = this.state;
    return (
      <div className={this.state.submitting ? "gray-out" : " "}>
        <SchoolAdminDashboard />

        <div className="content-layout add-sectionn">
          <>
            <CssBaseline />
            <ElevationScroll {...props}>
              <div>
                <Toolbar className="tb-p">
                  <div className="mng-add-header">
                    <div>
                      {this.id && (
                        <Link to={`/teamdetails/${this.id}`}>
                          <span className="backbtn">
                            <img src={backarrow} alt="back"></img>
                          </span>
                        </Link>
                      )}
                      <span className="txt-blue bold fs-18">EDIT TEAM</span>
                    </div>

                    <div>
                      <button
                        type="button"
                        className="cancelbtn mr-2"
                        onClick={this.openDialog.bind(this)}
                      >
                        Cancel
                      </button>

                      {/* cancel pop up */}
                      <Dialog
                        id="dialogBox"
                        className="dialog-style"
                        open={this.state.open}
                        onClose={this.closeDialog.bind(this)}
                      >
                        <DialogTitle>
                          <div className="row">
                            <div className="col-1 text-right ml-auto ">
                              <FaTimes
                                onClick={this.closeDialog.bind(this)}
                                className="crossview cp"
                              />
                            </div>
                          </div>
                        </DialogTitle>
                        <DialogContent>
                          <div className="clear10"></div>
                          <div className="row">
                            <div className="col-12 text-center">
                              <p className="fs-20 semi-bold text-center mb-4">
                                Are you sure you want to cancel?
                              </p>
                              <div className="clear10"></div>
                            </div>
                            <div className="col-5 col-md-3 col-lg-3 ml-auto text-center">
                              <button
                                type="button"
                                class="cancelbtn mr-3 canBtn"
                                onClick={this.closeDialog.bind(this)}
                              >
                                No
                              </button>
                            </div>
                            <div className="col-5 col-md-3 col-lg-3 mr-auto text-center ">
                              <Link to="/schoolteams">
                                <button
                                  type="button"
                                  class="yes-btn ml-3 delBtn"
                                >
                                  Yes, Cancel
                                </button>
                              </Link>
                            </div>
                          </div>

                          <div className="clear10"></div>

                          <div className="clear10"></div>
                        </DialogContent>
                      </Dialog>
                      <button
                        type="submit"
                        className={
                          disabled == false ? "saveBtn1" : "saveBtn1 activv"
                        }
                        disabled={disabled}
                        onClick={this.registerSchoolAdmin}
                      >
                        Update
                      </button>

                      {/* update modal */}
                      <Dialog
                        id="dialogBoxSuccessTeam"
                        open={this.state.openSuccess}
                        onClose={this.closeDialogSuccess.bind(this)}
                      >
                        <DialogTitle>
                          <div className="row">
                            <div className="col-1 text-right ml-auto">
                              <FaTimes
                                onClick={this.closeDialogSuccess.bind(this)}
                                className="crossview cp"
                              />
                            </div>
                          </div>
                        </DialogTitle>
                        <DialogContent>
                          <div className="clear10"></div>
                          <div className="row">
                            <div className="col-12 text-center">
                              <img
                                src={successimg}
                                alt="success"
                                className="successimg-new"
                              ></img>
                              <div className="clear20"></div>
                              <p className="fs-20 semi-bold text-center">
                                Team updated Successfully!
                              </p>
                              <div className="clear30"></div>
                            </div>
                            <div className="col-12 col-md-12 col-lg-12 ml-auto text-center">
                              <Link to="/schoolteams">
                                <button
                                  type="button"
                                  class="donebtn canBtn mg-bottom-20"
                                  onClick={this.closeDialogSuccess.bind(this)}
                                >
                                  DONE
                                </button>
                              </Link>
                            </div>
                          </div>
                        </DialogContent>
                      </Dialog>
                    </div>
                  </div>
                </Toolbar>
              </div>
            </ElevationScroll>
            <div className="clear10"></div>
            {submitting && (
              <CircularProgress
                style={{
                  width: "45px",
                  height: "44px",
                  position: "absolute",
                  left: "50%",
                  top: "50%",
                  zIndex: "99",
                }}
                color="secondary"
              />
            )}
            <Container>
              <form name="adminRegistrationForm">
                <div className="row">
                  <div className="col-12 col-sm-12 col-lg-5 col-md-12">
                    <div className="moboMargin-5">
                      <div className="white-card">
                        <div className="row">
                          <div className="col-3 col-sm-3 col-md-3 col-lg-3">
                            {this.state.imagePreviewUrl && (
                              <img
                                src={this.state.imagePreviewUrl}
                                className="img-fluid profileStyle"
                                alt=""
                              ></img>
                            )}
                            {!this.state.imagePreviewUrl && (
                              <Avatar className="avatar">
                                <PhotoSizeSelectActualOutlinedIcon />
                              </Avatar>
                            )}
                          </div>
                          <div className="align-self col-9 col-sm-9 col-md-6 col-lg-6">
                            <label
                              htmlFor="upload-photo-1"
                              className="form-control semi-bold txt-blue cp mb-0"
                            >
                              Update Profile Photo
                            </label>
                            <input
                              type="file"
                              name="photo"
                              accept="image/png, image/gif, image/jpeg"
                              id="upload-photo-1"
                              onChange={this.changeHandlerForLogo}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="clear20"></div>
                      <div className="white-card">
                        <div className="row fs-18 ">
                          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                            <div className="row">
                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                <FormGroup>
                                  <label className="fmlabel mt-6 semi-bold ">
                                    Team Name <span className="redstar">*</span>
                                  </label>
                                  <input
                                    className="form-control regular"
                                    type="text"
                                    name="firstName"
                                    id="firstName"
                                    value={this.state.teamName}
                                    onChange={(e) => {
                                      this.setState({
                                        teamName: e.target.value,
                                      });
                                    }}
                                    placeholder="Enter Name"
                                  ></input>
                                  <div className="errorMsg fs-14 medium">
                                    {this.state.errors.firstName}
                                  </div>
                                </FormGroup>
                              </div>
                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                <FormGroup>
                                  <label className="fmlabel mt-6 semi-bold ">
                                    Created By{" "}
                                    <span className="redstar">*</span>
                                  </label>
                                  <input
                                    className="form-control regular"
                                    type="text"
                                    name=" Created By "
                                    id=" Created By "
                                    value={this.state.fields.email}
                                    onChange={(e) => {
                                      this.setState({ email: e.target.value });
                                    }}
                                    disabled
                                    placeholder=" Created By "
                                  ></input>
                                  <div className="errorMsg fs-14 medium">
                                    {this.state.errors.email}
                                  </div>
                                </FormGroup>
                              </div>
                            </div>
                            <div className="clear10"></div>
                            <div className="row">
                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                <FormGroup>
                                  <label className="fmlabel mt-6 semi-bold ">
                                    Created On{" "}
                                    <span className="redstar">*</span>
                                  </label>
                                  <input
                                    className="form-control regular"
                                    name="createdAt"
                                    value={moment(this.state.createdAt).format(
                                      "MM/DD/YYYY"
                                    )}
                                    placeholder=""
                                    onChange={(e) => {
                                      this.setState({
                                        createdAt: e.target.value,
                                      });
                                    }}
                                    disabled
                                  ></input>
                                  <div className="errorMsg fs-14 medium">
                                    {this.state.errors.mobileno}
                                  </div>
                                </FormGroup>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="clear20"></div>
                      <div className="white-card">
                        <div className="row fs-18 ">
                          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                            <div className="row">
                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                <FormGroup>
                                  <label className="fmlabel mt-6 semi-bold ">
                                    Coaches
                                  </label>
                                  <Multiselect
                                    options={this.state.coachesData} // Options to display in the dropdown
                                    selectedValues={
                                      this.state.selectedValueCoaches
                                    } // Preselected value to persist in dropdown
                                    onSelect={this.onSelect} // Function will trigger on select event
                                    onRemove={this.onRemove} // Function will trigger on remove event
                                    displayValue="name" // Property name to display in the dropdown options
                                  />
                                </FormGroup>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="clear20"></div>
                      <div className="white-card">
                        <div className="row fs-18 ">
                          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                            <div className="row">
                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                <FormGroup>
                                  <label className="fmlabel mt-6 semi-bold ">
                                    Athlets
                                  </label>
                                  <Multiselect
                                    options={this.state.atheleteData} // Options to display in the dropdown
                                    selectedValues={
                                      this.state.selectedValueAthelete
                                    } // Preselected value to persist in dropdown
                                    onSelect={this.onSelectAthelete} // Function will trigger on select event
                                    onRemove={this.onRemoveAthelete} // Function will trigger on remove event
                                    displayValue="name" // Property name to display in the dropdown options
                                  />
                                </FormGroup>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="clear20"></div>
                      <div className="clear20"></div>
                    </div>
                  </div>
                  <div className="col-5"></div>
                  <div className="clear20"></div>
                </div>
              </form>
              <div className="clear40"></div>
            </Container>
          </>
        </div>
      </div>
    );
  }
}
export default withRouter(EditTeams);
